import BaseComponent from '../BaseComponent';
import { ClassNames } from '../../utils/dom/css-classes';
import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import { GEOLOCATION_CHANGE_EVENT } from '../LocationSearch/LocationSearch';
import LocationSearch from '../LocationSearch/LocationSearch';
import Manipulator from '../../utils/dom/manipulator';

const NAME = 'SimpleLocationSearch';

class SimpleLocationSearch extends BaseComponent {
	constructor(element) {
		super(element);
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		const form = SelectorEngine.findOne('.js-court-search-location-form', this._element);
		const submitButton = SelectorEngine.findOne('.lta-simple-location-search__find-btn', this._element);
		const locationComponent = SelectorEngine.findOne('.js-lta-location-search', this._element);
		if (locationComponent) {
			LocationSearch.getOrCreateInstance(locationComponent);
		}
		const latInput = SelectorEngine.findOne('.js-location-lat-field-input', this._element);
		const lonInput = SelectorEngine.findOne('.js-location-lon-field-input', this._element);
		const locationInput = SelectorEngine.findOne('.js-location-search-field-input', this._element);

		const strictSearch = Manipulator.getDataAttribute(locationComponent, 'strictSearch');

		EventHandler.on(locationInput, 'input', () => {
			latInput.value = '';
			lonInput.value = '';

			locationComponent.classList.remove(ClassNames.Invalid);
			submitButton.disabled = false;
		});

		EventHandler.on(locationInput, GEOLOCATION_CHANGE_EVENT, (event) => {
			latInput.value = event.lat;
			lonInput.value = event.lng;
		});

		EventHandler.on(submitButton, 'click', () => {
			const formData = new FormData(form);
			const data = [...formData.entries()];

			const [, locationValue] = data.find(([field]) => field === 'location');
			const [, latitude] = data.find(([field]) => field === 'latitude');
			const [, longitude] = data.find(([field]) => field === 'longitude');

			locationComponent.classList.remove(ClassNames.Invalid);
			const isInvalidLocation = !locationValue;
			const isInvalidLatLong = !(latitude && longitude);

			if (isInvalidLocation || (strictSearch && isInvalidLatLong)) {
				locationComponent.classList.add(ClassNames.Invalid);
				return;
			}

			const initParams = `?fltr=y&${data[2][0]}=${data[2][1]}&${data[0][0]}=${data[0][1]}&${data[1][0]}=${data[1][1]}`

			window.location.href = Manipulator.getDataAttribute(this._element, 'url') + initParams + Manipulator.getDataAttribute(this._element, 'params');
		});
	}
}

export default SimpleLocationSearch;
